import React from 'react';
import { USAProvider } from './USAContext';
import SmartUSADashboard from './SmartUSADashboard';

const USAHelper = () => {
    return (
        <USAProvider>
            <SmartUSADashboard />
        </USAProvider>
    );
};

export default USAHelper;